import { Message } from "@/types/chat";
import { ChatContainer } from "./chat/ChatContainer";

interface ChatMessagesProps {
  messages: Message[];
  isLoading?: boolean;
}

export function ChatMessages({ messages, isLoading }: ChatMessagesProps) {
  return <ChatContainer messages={messages} isLoading={isLoading} />;
}